<template>
  <div>
    <el-collapse accordion style="margin-bottom: 20px">
      <el-collapse-item title="検索条件" name="1">
        <!-- 查询条件 -->
        <el-form
          :model="searchForm"
          label-width="auto"
          style="max-width: 100%; position: relative"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="販売状況">
                <el-select v-model="searchForm.sold_out_flg" placeholder="選択">
                  <el-option label="" value=""></el-option>
                  <el-option label="販売中" value="0"></el-option>
                  <el-option label="売却済" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 20px">
              <el-form-item label="管理番号">
                <el-input
                  v-model="searchForm.management_number"
                  placeholder="入力"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="価格">
                <el-input
                  v-model="searchForm.price_min"
                  placeholder="入力"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="〜">
                <el-input
                  v-model="searchForm.price_max"
                  placeholder="入力"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="メーカー">
                <el-select v-model="searchForm.manufacturer" @change="fetchCarTypes" placeholder="選択">
                  <el-option
                    v-for="item in manufacturers"
                    :key="item.code"
                    :label="item.name_ja"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="車種">
                <el-select v-model="searchForm.type" placeholder="選択">
                  <el-option
                    v-for="item in carTypes2"
                    :key="item.code"
                    :label="item.name_ja"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item style="position: absolute; bottom: 0px; right: 10px">
            <el-button type="primary" @click="fetchCars">検索</el-button>
            <el-button @click="resetSearch">リセット</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <el-row justify="end">
      <el-col :span="4">
        <el-divider content-position="left">中古パーツ一覧</el-divider>
      </el-col>
      <el-col :span="20" style="text-align: right">
        <el-button type="primary" @click="openDialog('add')">追加</el-button>
      </el-col>
    </el-row>

    <el-table
      :data="cars"
      border
      stripe
      style="width: 100%; margin-top: 10px"
      :header-cell-style="{
        background: '#08455d',
        color: '#fff',
        fontWeight: 'bold',
      }"
    >
      <!-- パーツ信息 -->
      <el-table-column prop="sold_out_flg" label="販売状況" width="120">
        <template #default="scope">
          <el-tag :type="scope.row.sold_out_flg === '1' ? 'danger' : 'success'">
            {{ scope.row.sold_out_flg === "1" ? "売却済み" : "販売中" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="management_number" label="管理番号" width="150" />
      <!-- <el-table-column prop="price_ja" label="価格" width="120" /> -->
      <el-table-column prop="price_ja" label="価格" width="120">
        <template #default="scope">
          {{ formatYen(scope.row.price_ja) }}
        </template>
      </el-table-column>
      <el-table-column prop="manufacturer" label="メーカー" width="120">
        <template #default="scope">
          {{ getManufacturerName(scope.row.manufacturer) }}
        </template>
      </el-table-column>

      <el-table-column prop="type" label="車種" width="120">
        <template #default="scope">
          {{ getCarTypeName(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="model_ja" label="型式" width="120" />
      <!-- <el-table-column prop="year_ja" label="年式" width="120" /> -->
      <el-table-column prop="year_ja" label="年式" width="120">
        <template #default="scope">
          {{ formatYearMonth2(scope.row.year_ja) }}
        </template>
      </el-table-column>

      <el-table-column prop="evaluation_ja" label="評価点" width="120" />
      <el-table-column prop="grade_ja" label="グレード" width="120" />

      <el-table-column prop="publish_date_ja" label="掲載日" width="120">
        <template #default="scope">
          {{ formatYearMonthDay2(scope.row.publish_date_ja) }}
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" width="200" fixed="right">
        <template #default="scope">
          <el-button
            size="small"
            @click="openDialog('view', scope.row)"
            type="success"
            >詳細</el-button
          >
          <el-button
            size="small"
            type="warning"
            @click="openDialog('edit', scope.row)"
            >修正</el-button
          >
          <el-button
            size="small"
            type="danger"
            @click="deleteCar(scope.row.management_number)"
            >削除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      background
      layout="total, sizes, prev, pager, next"
      :total="totalItems"
      :page-size="pageSize"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      prev-text="前へ"
      next-text="次へ"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      style="margin-top: 10px; text-align: right"
    >
    </el-pagination>

    <!--  车辆信息 Dialog -->
    <PartInfoDialog
      v-model:visible="dialogVisible"
      :mode="dialogMode"
      :carInfo="selectedCar"
      @update:visible="dialogVisible = $event"
      @refreshList="fetchCars"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import {
  ElMessage,
  ElMessageBox,
  ElLoading,
} from "element-plus";
import { supabase } from "@/supabase.js"; // Supabase 连接
import {
  formatMileage as UformatMileage,
  formatDisplacement as UformatDisplacement,
  formatYearMonthDay2 as UformatYearMonthDay2,
  formatYen3 as UformatYen,
  formatYearMonth2 as UformatYearMonth2,
} from "@/utils/utils.js";
import PartInfoDialog from "@/components/PartInfoDialog.vue"; // 引入组件

export default {
  components: {
    PartInfoDialog, // 注册组件
  },
  setup() {
    const router = useRouter();
    const cars = ref([]);
    const detailsVisible = ref(false);
    const selectedCar = ref({});
    //  查询条件
    const searchForm = ref({
      sold_out_flg: "", // 販売状況
      management_number: "", // 管理番号
      price_min: "", // 価格
      price_max: "",
      manufacturer: "", // メーカー
      type: "", // 車種
    });
    const manufacturers = ref([]); // 车辆制造商
    const carTypes = ref([]); // 车辆种类
    const carTypes2 = ref([]); // 车辆种类

    // 分页
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalItems = ref(0);

    // 控制 Dialog 显示
    const dialogVisible = ref(false);
    const dialogMode = ref(""); // "add" / "view" / "edit"

    // 🚗 获取车辆列表
    const fetchCars = async () => {
      // 开启 loading 动画
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let quertCount = supabase
        .from("part_info")
        .select("*", { count: "exact", head: false });

      let query = supabase.from("part_info").select("*");
      // .select(
      //   "management_number, price_ja, manufacturer, type, year_ja, mileage_ja, inspection_ja, evaluation_ja, grade_ja, model_ja, color_ja, shift_ja, drive_method_ja, turbo_ja, displacement_ja, points_ja, publish_date_ja, sold_out_flg"
      // );
      // .select("*“);

      if (searchForm.value.sold_out_flg) {
        query = query.eq("sold_out_flg", searchForm.value.sold_out_flg);
        quertCount = quertCount.eq(
          "sold_out_flg",
          searchForm.value.sold_out_flg
        );
      }
      if (searchForm.value.management_number) {
        query = query.ilike(
          "management_number",
          `%${searchForm.value.management_number}%`
        );
        quertCount = quertCount.ilike(
          "management_number",
          `%${searchForm.value.management_number}%`
        );
      }
      if (searchForm.value.price_min && searchForm.value.price_max) {
        query = query
          .gte("price_ja", searchForm.value.price_min)
          .lte("price_ja", searchForm.value.price_max);
        quertCount = quertCount
          .gte("price_ja", searchForm.value.price_min)
          .lte("price_ja", searchForm.value.price_max);
      }
      if (searchForm.value.manufacturer) {
        query = query.eq("manufacturer", searchForm.value.manufacturer);
        quertCount = quertCount.eq(
          "manufacturer",
          searchForm.value.manufacturer
        );
      }
      if (searchForm.value.type) {
        query = query.eq("type", searchForm.value.type);
        quertCount = quertCount.eq("type", searchForm.value.type);
      }

      //   // 先获取 **总件数**
      const { count, error: countError } = await quertCount;

      if (countError) {
        console.error("件数取得エラー:", countError);
      } else {
        totalItems.value = count; // 赋值总件数
      }

      // 分页
      const start = (currentPage.value - 1) * pageSize.value;
      const end = start + pageSize.value - 1;
      query = query.range(start, end);

      const { data, error } = await query;

      if (error) {
        // 关闭 loading 动画
        loading.close();
        console.error("データ取得エラー:", error);
      } else {
        // 关闭 loading 动画
        loading.close();
        cars.value = data;
      }
    };

    // 处理分页切换
    const handlePageChange = (page) => {
      currentPage.value = page;
      fetchCars();
    };

    // 处理每页显示数量切换
    const handleSizeChange = (size) => {
      pageSize.value = size;
      currentPage.value = 1;
      fetchCars();
    };

    // 📌 获取制造商 & 车型数据
    const fetchOptions = async () => {
      const { data: manufacturersData } = await supabase
        .from("manufacturer_m")
        .select("code, name_ja");
      const { data: carTypesData } = await supabase
        .from("model_m")
        .select("code, name_ja");
      manufacturers.value = manufacturersData || [];
      carTypes.value = carTypesData || [];
    };

    const fetchCarTypes = async () => {
      if (!searchForm.value.manufacturer) return;
      const { data } = await supabase
        .from("model_m")
        .select("code, name_ja")
        .eq("m_code", searchForm.value.manufacturer);
      carTypes2.value = data || [];
    };

    // 🚗 删除车辆
    const deleteCar = async (management_number) => {
      ElMessageBox.confirm("このパーツを削除しますか？", "確認", {
        confirmButtonText: "削除",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(async () => {
          const { error } = await supabase
            .from("part_info")
            .delete()
            .eq("management_number", management_number);

          if (error) {
            ElMessage.error("削除に失敗しました。");
          } else {
            ElMessage.success("削除しました。");
            fetchCars(); // 重新获取列表
          }
        })
        .catch(() => {
          ElMessage.info("削除をキャンセルしました。");
        });
    };

    // 🚗 查看详情
    const showDetails = (car) => {
      selectedCar.value = car;
      detailsVisible.value = true;
    };

    // 🚗 跳转到添加页面
    const goToAddPage = () => {
      router.push("/car/add");
    };

    // 🚗 跳转到修改页面
    const goToEditPage = (management_number) => {
      router.push(`/car/edit/${management_number}`);
    };

    // 打开对话框
    const openDialog = (mode, car = {}) => {
      console.log("openDialog:" + mode);
      dialogMode.value = mode;
      selectedCar.value = mode === "add" ? {} : car;
      dialogVisible.value = true;
    };

    // resetSearch
    const resetSearch = () => {
      searchForm.value = {
        sold_out_flg: "",
        management_number: "",
        price_min: "",
        price_max: "",
        manufacturer: "",
        type: "",
      };
    };

    const getManufacturerName = (code) => {
      const manufacturer = manufacturers.value.find((m) => m.code == code);
      return manufacturer ? manufacturer.name_ja : "-"; // 如果找不到就返回 "-"
    };

    const getCarTypeName = (code) => {
      const carType = carTypes.value.find((t) => t.code == code);
      return carType ? carType.name_ja : "-"; // 如果找不到就返回 "-"
    };

    const formatYen = (value) => {
      return UformatYen(value);
    };

    const formatMileage = (value) => {
      return UformatMileage(value);
    };

    const formatDisplacement = (value) => {
      return UformatDisplacement(value);
    };
    const formatYearMonthDay2 = (value) => {
      return UformatYearMonthDay2(value);
    };

    const formatYearMonth2 = (value) => {
      return UformatYearMonth2(value);
    };

    onMounted(async () => {
      await fetchOptions();
      await fetchCars();
    });

    return {
      cars,
      detailsVisible,
      selectedCar,
      deleteCar,
      showDetails,
      goToAddPage,
      goToEditPage,
      searchForm,
      fetchCars,
      resetSearch,
      manufacturers,
      carTypes,
      getManufacturerName,
      getCarTypeName,
      formatYen,
      formatMileage,
      formatDisplacement,
      formatYearMonthDay2,
      formatYearMonth2,
      currentPage,
      pageSize,
      totalItems,
      handlePageChange,
      handleSizeChange,
      dialogVisible,
      dialogMode,
      openDialog,
      fetchCarTypes,
      carTypes2
    };
  },
};
</script>
<style scoped>
.el-divider >>> .el-divider__text {
  background-color: #f5f5f5 !important;
  color: var(--el-text-color-primary);
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  position: absolute;
}
.ellipsis-text {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制最多显示2行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap; /* 保留换行 */
  word-break: break-word;
  max-height: 3.2em; /* 适应2行 */
  line-height: 1.6em;
}
.el-collapse {
  --el-collapse-border-color: var(--el-border-color-lighter);
  --el-collapse-header-height: 48px;
  --el-collapse-header-bg-color: none;
  --el-collapse-header-text-color: var(--el-text-color-primary);
  --el-collapse-header-font-size: 13px;
  --el-collapse-content-bg-color: none;
  --el-collapse-content-font-size: 13px;
  --el-collapse-content-text-color: var(--el-text-color-primary);
  border-bottom: 1px var(--el-border-color) var(--el-border-style);
  border-top: 1px var(--el-border-color) var(--el-border-style);
}
</style>
